
export class Reset {
  static readonly type = '[Processing] Reset';
}

export class SetEmailSending {
  static readonly type = '[Processing] Set Email Sending';
  constructor(public isSending: boolean) {}
}

export class SetProcessing {
  static readonly type = '[Processing] Set Processing';
  constructor(public isProcessing: boolean) {}
}

export class SetMessage {
  static readonly type = '[Processing] Set Message';
  constructor(public message: string) {}
}

export class ClearMessage {
  static readonly type = '[Processing] Clear Message';
}

export class SetError {
  static readonly type = '[Processing] Set Error';
  constructor(public error: string) {}
}

export class ClearError {
  static readonly type = '[Processing] Clear Error';
}
